import { useTranslation } from 'react-i18next';

import { get, omit } from 'lodash';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

import { isString, isObject } from '@common/helpers/helpers';

const StyleSelect = styled(({ ...other }) => (
  <Select {...omit(other, 'backgroundField')} />
))(({ theme, backgroundField }) => ({
  background: backgroundField ? backgroundField : '#FFF',
  '& .MuiSvgIcon-root': { color: theme.palette.primary.main },
}));

const menuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
    },
  },
};

const SelectInput = ({
  name,
  options = [],
  touched = {},
  errors = {},
  value,
  accessors: { valueAccessor = 'id', textAccessor = 'value' } = {},
  required = false,
  disabled = false,
  helperText = '',
  label = '',
  onBlur = () => {},
  isNoneOptionVisible = false,
  isSelectWithFlag = false,
  backgroundField = true,
  ...props
}) => {
  const { t } = useTranslation();
  const getValue = (option, propName) => {
    if (isString(option)) {
      return option;
    }
    if (isObject(option)) {
      if (propName === textAccessor) return option[textAccessor] ?? '';
      if (propName === valueAccessor) return option[valueAccessor] ?? '';
    }
    return '';
  };

  return (
    <>
      <InputLabel
        required={required}
        id={name}
        disabled={disabled}
        error={Boolean(get(touched, name) && get(errors, name))}
      >
        {label}
      </InputLabel>
      <StyleSelect
        backgroundField={backgroundField}
        size='small'
        IconComponent={KeyboardArrowDownIcon}
        labelId={name}
        name={name}
        placeholder='Select'
        value={value ?? ''}
        onBlur={() => onBlur({ target: { name } })}
        error={Boolean(get(touched, name) && get(errors, name))}
        disabled={disabled}
        MenuProps={menuProps}
        {...props}
        label={label}
      >
        {isNoneOptionVisible && (
          <MenuItem value=''>
            <em>{t('none')}</em>
          </MenuItem>
        )}

        {options.map((option, index) => (
          <MenuItem
            key={index}
            value={getValue(option, valueAccessor)}
            disabled={option?.disabled}
            sx={{ display: 'flex' }}
          >
            <Box sx={{ display: 'inline' }}>
              {getValue(option, textAccessor)}
            </Box>
          </MenuItem>
        ))}
      </StyleSelect>
      {get(touched, name) && get(errors, name) && (
        <FormHelperText error={true}>{get(errors, name)}</FormHelperText>
      )}
      {helperText && (
        <FormHelperText id='component-helper-text'>
          {t(helperText)}
        </FormHelperText>
      )}
    </>
  );
};

export default SelectInput;
